import { characteristicsWithSearch, characteristicsAvailable, selectedCharacteristicIds } from 'model/EvidenceSearch'
import { AttributesGrid } from './AttributesGrid'
import { reactive, VString } from 'alkali'
import { addCharacteristic } from 'model/EvidenceSearch'
import { CharacteristicDropdown } from './CharacteristicDropdown'

export class CharacteristicsGrid extends AttributesGrid.with({
	selectionMode: 'toggle',
	selected: selectedCharacteristicIds,
	Dropdown: CharacteristicDropdown,
	id: 'characteristic-filter-grid',
}) {
	created(properties) {
		properties.collection = characteristicsAvailable
		properties.placeholder = 'For patients with ...'
		properties.label = 'Condition'
		properties.attributeType = 'characteristic'
		properties.addTerm = addCharacteristic
	}
}